var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "module-preview", style: _vm.getModulePreviewStyle() },
    [
      _c("div", {
        staticClass: "module-icon",
        style: _vm.getModuleIconStyle(),
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "module-text", style: _vm.getModuleTextStyle() },
        [
          _vm._v(
            " " +
              _vm._s(
                _vm.module.tmo_data && !_vm.module.modu_act_id
                  ? _vm.module.tmo_data.name
                  : _vm.module.modu_name
              )
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }